import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Url } from 'app/shared/constants/url';
import { BankFilter } from 'app/shared/filters/bank.filter';
import { Bank } from 'app/shared/models/bank.model';
import { GenericService } from 'app/shared/services/generic.service';
import { SelectionListBaseComponent } from '../selection-list-base/selection-list-base.component';

@Component({
  selector: 'app-bank-selection-list',
  templateUrl: './bank-selection-list.component.html',
  styleUrls: ['./bank-selection-list.component.scss']
})

export class BankSelectionListComponent extends SelectionListBaseComponent<Bank> implements OnInit, OnChanges {

  @Input() companyId: number;

  constructor(private genericService: GenericService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.companyId) {
      this.selectedObject = undefined;
      this.loadSelectionList();
    }
  }

  protected loadSelectionList(): void {
    this.selectionList$ = this.genericService.getList<Bank>(Url.Banks, new BankFilter(this.companyId));
  }
}
